import CONTACTS from 'consts/contacts.consts';

function getContactStatus(status) {
  return CONTACTS.STATUSES[status] ?? 'Desconocido';
}

export default {
  getContactStatus
};